import { InjectionToken } from '@angular/core';

export interface ReportExportFileService {
  saveExcelFile(buffer: ArrayBuffer | BlobPart, filename: string): Promise<void>;
}

export const REPORT_EXPORT_FILE_SERVICE = new InjectionToken<ReportExportFileService>('REPORT_EXPORT_FILE_SERVICE');
